
export const getSvgDataUri = (svgString: string) => {
    // Check if it's already a data URI or file path (from webpack svg-url-loader)
    if (svgString.startsWith('data:') || svgString.startsWith('/') || svgString.startsWith('http')) {
      return svgString;
    }
    // If it's raw SVG markup (from Angular esbuild), convert to data URI
    return `data:image/svg+xml,${encodeURIComponent(svgString)}`;
};